import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { ClientService } from 'src/app/services/user/client.service';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { Client } from 'src/app/shared/models';

@Component({
  selector: 'app-client-detail',
  templateUrl: './client-detail.component.html',
  styleUrls: ['./client-detail.component.scss']
})
export class ClientDetailComponent extends DestructorComponent implements OnInit {

  userId: string = '';
  user: Client | any;
  isLoading: boolean = false;

  loginAsClientLoading: boolean = false;

  constructor(
    private _route: ActivatedRoute,
    private _clientService: ClientService,
    private _globalStateService: GlobalStateService
  ) {
    super();
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      this.userId = params['userId'];
      if (this.userId) {
        this.loadData(this.userId);
      }
    });
  }

  loadData(id: string) {
    this.isLoading = true;

    this.subscriptions.push(
      this._clientService.GetDataById(id).subscribe({
        next: (res: any) => {
          this.user = res.data;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading client:', error);
          this.isLoading = false;
        }
      })
    );
  }

  getAvatarDisplay(): { type: 'image' | 'initial', value: string, bgClass?: string } {
    if (this.user?.avatar && this.user.avatar.trim() !== '') {
      return { type: 'image', value: this.user.avatar };
    }

    const name = this.user?.name || this.user?.email || 'C';
    const initial = name.charAt(0).toUpperCase();
    const bgClasses = ['bg-light-primary text-primary', 'bg-light-success text-success',
      'bg-light-info text-info', 'bg-light-warning text-warning',
      'bg-light-danger text-danger'];
    const bgClass = bgClasses[initial.charCodeAt(0) % bgClasses.length];

    return { type: 'initial', value: initial, bgClass };
  }

  getRatingBadgeClass(): string {
    switch (this.user?.rating) {
      case 'gold': return 'badge-light-warning';
      case 'silver': return 'badge-light-secondary';
      case 'platinum': return 'badge-light-info';
      default: return 'badge-light-secondary';
    }
  }

  loginAsClient(): void {
    const clientId = this.user?._id || this.user?.doc_id;
    if (!clientId) {
      console.error('Client ID not found');
      return;
    }

    this.loginAsClientLoading = true;

    this.subscriptions.push(
      this._clientService.LoginAsClient(clientId).subscribe({
        next: (response) => {
          this.loginAsClientLoading = false;
          let ssoCode = response.data.ssoCode;
          window.open(`${this._globalStateService.websiteURL}/auth/sso?auth_code=${ssoCode}`, '_blank');
        },
        error: (error) => {
          console.error('Error logging in as client:', error);
          this.loginAsClientLoading = false;
        }
      })
    );
  }

  openBidHistory(): void {
    const clientId = this.user?._id || this.user?.doc_id;
    window.open('/bid-manager/my-bids?client_id=' + clientId, '_blank');
  }

}
